<mat-card appearance="outlined">
  <mat-card-title class="tw-flex tw-justify-between">
    <div class="tw-flex tw-items-center">
      <ui-svg-icon [name]="iconNameList.Calendar" [width]="32"></ui-svg-icon>
      {{ subscriptionTitleTranslationKey | translate }}
    </div>
    <mat-slide-toggle [formControl]="subscriptionStateControl" class="tw-self-center" color="primary">
      {{ 'common.field.active' | translate }}
    </mat-slide-toggle>
  </mat-card-title>
  <mat-card-content *ngIf="subscriptionForm" [formGroup]="subscriptionForm">
    <div class="schedule-type-field">
      <div class="tw-flex tw-flex-col">
        <label class="schedule-type-field_label">
          {{ 'common.field.frequency' | translate }}
        </label>

        <div class="tw-flex tw-justify-between tw-items-center">
          <mat-button-toggle-group formControlName="schedulingType">
            <mat-button-toggle
              *ngFor="let type of [schedulingType.Daily, schedulingType.Weekly]"
              [value]="type"
              aria-label="{{ type }}"
            >
              {{ 'common.filter.profileType.option.' + type.toLowerCase() | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>

          <mat-slide-toggle
            *ngIf="subscriptionForm.get('receiveEmptyEmails')"
            formControlName="receiveEmptyEmails"
            class="tw-self-center"
          >
            {{ 'monitoring.profile.item.receiveEmptyEmail' | translate }}
          </mat-slide-toggle>
          <mat-slide-toggle
            *ngIf="subscriptionForm.get('receiveExcelAttachment')"
            formControlName="receiveExcelAttachment"
            class="tw-self-center"
          >
            {{ 'monitoring.profile.item.receiveExcelAttachment' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <mat-form-field *ngIf="schedulingTypeControl.value === schedulingType.Weekly">
      <mat-label>{{ 'common.field.selectDay' | translate }}</mat-label>
      <mat-select formControlName="day">
        <mat-option *ngFor="let day of dayOfWeekOptions" [value]="day">
          {{ 'common.dayOfWeek.' + (day | lowercase) | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="validationService.hasError(subscriptionForm, 'day', 'required')"
        >{{ 'common.validation.error.required' | translate }}
      </mat-error>
    </mat-form-field>

    <ng-container *ngIf="(isMultiHours$ | async) && schedulingTypeControl.value === schedulingType.Daily">
      <ng-container *ngTemplateOutlet="hours; context: { control: dailyHoursControl, isMultiple: true }"></ng-container>
    </ng-container>

    <ng-container *ngIf="(isMultiHours$ | async) && schedulingTypeControl.value === schedulingType.Weekly">
      <ng-container
        *ngTemplateOutlet="hours; context: { control: weeklyHoursControl, isMultiple: false }"
      ></ng-container>
    </ng-container>

    <ng-container *ngIf="!(isMultiHours$ | async)">
      <ng-container
        *ngTemplateOutlet="hours; context: { control: subscriptionForm.get('hours'), isMultiple: false }"
      ></ng-container>
    </ng-container>

    <ng-template let-control="control" let-isMultiple="isMultiple" #hours>
      <mat-form-field *ngIf="control">
        <mat-label>{{ 'common.field.selectTime' | translate }}</mat-label>
        <mat-select [formControl]="control" [multiple]="isMultiple">
          <mat-option *ngFor="let hour of hourOptions" [value]="hour">
            {{ (hour.toString().length === 1 ? '0' : '') + hour + ':00' }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <ng-container *ngIf="subscriptionForm.get('emails') as emailsControl">
      <ui-chip-field [formControl]="emailsControl" [label]="'common.field.emails'"></ui-chip-field>
      <div class="emails-error">
        <mat-error>
          <ui-field-error-messages [control]="subscriptionForm.get('emails')"></ui-field-error-messages>
        </mat-error>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
